import _Object$getPrototypeOf from 'babel-runtime/core-js/object/get-prototype-of';
import _classCallCheck from 'babel-runtime/helpers/classCallCheck';
import _createClass from 'babel-runtime/helpers/createClass';
import _possibleConstructorReturn from 'babel-runtime/helpers/possibleConstructorReturn';
import _inherits from 'babel-runtime/helpers/inherits';
import { Tracker } from '../Tracker';

export var SelfExclusionTracker = function (_Tracker) {
  _inherits(SelfExclusionTracker, _Tracker);

  function SelfExclusionTracker() {
    _classCallCheck(this, SelfExclusionTracker);

    return _possibleConstructorReturn(this, (SelfExclusionTracker.__proto__ || _Object$getPrototypeOf(SelfExclusionTracker)).apply(this, arguments));
  }

  _createClass(SelfExclusionTracker, [{
    key: 'selfExclusionTermsClicked',
    value: function selfExclusionTermsClicked() {
      this.publishPartialEvent('self_exclusion_WH_terms_click', {
        EventLabel: 'Terms & Conditions Click'
      });
    }
  }, {
    key: 'selfExclusionWhSuccessful',
    value: function selfExclusionWhSuccessful(_ref) {
      var attempt = _ref.attempt,
          period = _ref.period;

      this.publishPartialEvent('self_exclusion_WH_successful', {
        EventLabel: 'Self Exclusion Successful',
        EffortAttempt: String(attempt),
        SelfExclusionPeriod: String(period)
      });
    }
  }, {
    key: 'selfExclusionWhUnsuccessful',
    value: function selfExclusionWhUnsuccessful(_ref2) {
      var attempt = _ref2.attempt,
          period = _ref2.period,
          _ref2$error = _ref2.error,
          error = _ref2$error === undefined ? null : _ref2$error,
          _ref2$errorMessage = _ref2.errorMessage,
          errorMessage = _ref2$errorMessage === undefined ? null : _ref2$errorMessage,
          _ref2$field = _ref2.field,
          field = _ref2$field === undefined ? null : _ref2$field;

      this.publishPartialEvent('self_exclusion_WH_unsuccessful', {
        EventLabel: 'Self Exclusion Unsuccessful',
        EffortAttempt: String(attempt),
        SelfExclusionPeriod: String(period),
        ErrorCode: error,
        ErrorMessage: errorMessage,
        ErrorFields: field,
        ErrorFieldsAmount: field ? '1' : null
      });
    }
  }]);

  return SelfExclusionTracker;
}(Tracker);